/**
 * Modern Typography Scale for PACS Application
 * Refined, tighter scale with better letter-spacing for headings
 */

const FONT_PRIMARY = "'Founders Grotesk', 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif";

const typography = {
  fontFamily: FONT_PRIMARY,
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightSemiBold: 600,
  fontWeightBold: 700,

  // Display - For hero sections and large headings
  h1: {
    fontFamily: FONT_PRIMARY,
    fontWeight: 600,
    fontSize: '2.25rem',      // 36px
    lineHeight: 1.2,
    letterSpacing: '-0.02em',
    '@media (min-width:600px)': {
      fontSize: '2.5rem',     // 40px
    },
    '@media (min-width:900px)': {
      fontSize: '3rem',       // 48px
    },
  },

  // Page titles
  h2: {
    fontFamily: FONT_PRIMARY,
    fontWeight: 600,
    fontSize: '1.875rem',     // 30px
    lineHeight: 1.25,
    letterSpacing: '-0.01em',
  },

  // Section headings
  h3: {
    fontFamily: FONT_PRIMARY,
    fontWeight: 600,
    fontSize: '1.5rem',       // 24px
    lineHeight: 1.3,
    letterSpacing: '-0.01em',
  },

  // Card titles
  h4: {
    fontFamily: FONT_PRIMARY,
    fontWeight: 600,
    fontSize: '1.25rem',      // 20px
    lineHeight: 1.4,
  },

  // Subsection headings
  h5: {
    fontFamily: FONT_PRIMARY,
    fontWeight: 600,
    fontSize: '1.125rem',     // 18px
    lineHeight: 1.4,
  },

  // Small headings
  h6: {
    fontFamily: FONT_PRIMARY,
    fontWeight: 600,
    fontSize: '1rem',         // 16px
    lineHeight: 1.5,
  },

  // Body text - primary
  body1: {
    fontFamily: FONT_PRIMARY,
    fontWeight: 400,
    fontSize: '0.9375rem',    // 15px
    lineHeight: 1.6,
  },

  // Body text - secondary (smaller)
  body2: {
    fontFamily: FONT_PRIMARY,
    fontWeight: 400,
    fontSize: '0.875rem',     // 14px
    lineHeight: 1.6,
  },

  // Subtitle - for meta info
  subtitle1: {
    fontFamily: FONT_PRIMARY,
    fontWeight: 500,
    fontSize: '1rem',         // 16px
    lineHeight: 1.5,
  },

  // Subtitle smaller
  subtitle2: {
    fontFamily: FONT_PRIMARY,
    fontWeight: 500,
    fontSize: '0.875rem',     // 14px
    lineHeight: 1.5,
  },

  // Captions and labels
  caption: {
    fontFamily: FONT_PRIMARY,
    fontWeight: 400,
    fontSize: '0.75rem',      // 12px
    lineHeight: 1.5,
  },

  // Overline - for tags and categories
  overline: {
    fontFamily: FONT_PRIMARY,
    fontWeight: 600,
    fontSize: '0.6875rem',    // 11px
    lineHeight: 1.5,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
  },

  // Button text
  button: {
    fontFamily: FONT_PRIMARY,
    fontWeight: 500,
    fontSize: '0.875rem',     // 14px
    lineHeight: 1.5,
    letterSpacing: '0.02em',
    textTransform: 'none',    // No uppercase for modern look
  },

  // ===== Custom variants for backwards compatibility =====

  // Sidebar navigation items (preserved for compatibility)
  sidebarlistitem: {
    fontFamily: FONT_PRIMARY,
    fontSize: '0.9375rem',    // 15px (reduced from 22px)
    fontWeight: 500,
    lineHeight: 1.4,
  },

  // Table headers
  tableHeader: {
    fontFamily: FONT_PRIMARY,
    fontWeight: 600,
    fontSize: '0.8125rem',    // 13px
    lineHeight: 1.5,
    letterSpacing: '0.02em',
  },

  // Form labels
  label: {
    fontFamily: FONT_PRIMARY,
    fontWeight: 500,
    fontSize: '0.875rem',     // 14px
    lineHeight: 1.5,
  },

  // Data display (for tables, lists)
  data: {
    fontFamily: FONT_PRIMARY,
    fontWeight: 400,
    fontSize: '0.875rem',     // 14px
    lineHeight: 1.5,
    fontFeatureSettings: '"tnum"', // Tabular numbers for alignment
  },
};

export default typography;
